import React from 'react';
import { MenuItemDef } from '@ag-grid-community/core';
import { Tooltip } from '@material-ui/core';
import { default as styles } from 'src/components/MassEdit/MassEdit.styles';
import { classes } from 'typestyle';
import { noop } from 'lodash';
import SquareActionButton from 'src/common-ui/components/Buttons/SquareActionButton';

export interface ConfigurablePostActionProps {
  action: MenuItemDef;
  dataLoading: boolean;
}

export const ConfigurablePostAction = ({ action, dataLoading }: ConfigurablePostActionProps) => {
  const { action: onClick = noop, icon, name, tooltip = '' } = action;
  return (
    <Tooltip title={tooltip} placement="bottom-end" enterDelay={0}>
      <div className={styles.actionButtonGroup} style={{ cursor: !dataLoading ? 'pointer' : 'not-allowed' }}>
        <SquareActionButton
          type="secondary"
          className={classes( styles.actionButtonButton, styles.massEditActionButton)}
          disabled={dataLoading}
          onClick={onClick}
          icon={icon as string}
          text={name || ''}
        />
      </div>
    </Tooltip>
  );
};
